import initTabs from '../parts/tabs';
const SELECTOR = '.block-legal';
const TAB_SELECTOR = '[role="tab"]';
const TABLIST_SELECTOR = '[role="tablist"]';
const SYNC_INIT_ATTR = 'data-legal-hash-sync-init';
const LEGAL_NAV_LINK_SELECTOR = '.site-footer__legal-list a';
const activateFromHash = (block) => {
    const slug = decodeURIComponent(window.location.hash.replace(/^#/, ''));
    if (!slug)
        return;
    const target = block.querySelector(`${TAB_SELECTOR}[data-slug="${CSS.escape(slug)}"]`);
    if (!target || target.getAttribute('aria-selected') === 'true')
        return;
    target.click();
    block.scrollIntoView({ behavior: 'smooth', block: 'start' });
};
const syncFooterLegalNav = () => {
    const links = Array.from(document.querySelectorAll(LEGAL_NAV_LINK_SELECTOR));
    if (!links.length)
        return;
    const currentPath = window.location.pathname.replace(/\/$/, '');
    const currentHash = window.location.hash;
    links.forEach((link) => {
        const url = new URL(link.href, window.location.href);
        const isActive = url.pathname.replace(/\/$/, '') === currentPath && url.hash === currentHash;
        link.closest('li')?.classList.toggle('current-menu-item', isActive);
    });
};
const syncUrlToActiveTab = (block) => {
    const tablist = block.querySelector(TABLIST_SELECTOR);
    if (!tablist || tablist.hasAttribute(SYNC_INIT_ATTR))
        return;
    tablist.setAttribute(SYNC_INIT_ATTR, '');
    const sync = () => {
        const active = tablist.querySelector(`${TAB_SELECTOR}[aria-selected="true"]`);
        const slug = active?.dataset.slug;
        if (!slug)
            return;
        const nextHash = `#${slug}`;
        if (window.location.hash !== nextHash) {
            window.history.replaceState(null, '', nextHash);
        }
        syncFooterLegalNav();
    };
    new MutationObserver(sync).observe(tablist, {
        attributes: true,
        attributeFilter: ['aria-selected'],
        subtree: true,
    });
    sync();
};
const initBlock = (block) => {
    initTabs(block);
    activateFromHash(block);
    syncUrlToActiveTab(block);
};
const init = () => {
    document.querySelectorAll(SELECTOR).forEach(initBlock);
};
document.addEventListener('DOMContentLoaded', init);
window.addEventListener('hashchange', () => {
    document.querySelectorAll(SELECTOR).forEach(activateFromHash);
    syncFooterLegalNav();
});
if (window.acf) {
    window.acf.addAction('render_block_preview', init);
}
